export enum Determination {
  approved = 'approved',
  pending = 'pending',
  rejected = 'rejected',
}
export interface Range {
  min?: number;
  max?: number;
}

export type DateRange = {
  startDate: string;
  endDate: string;
};

export interface Paginated<T> {
  page: T[];
  totalPages: number;
  totalEntries: number;
}

export enum ClaimTypes {
  direct_notice = 'direct_notice',
  pop = 'pop',
  non_pop = 'non_pop',
}

export enum TimeInterval {
  Hour = 'hour',
  FourHourBlock = 'fourHourBlock',
  Day = 'day',
  Week = 'week',
  Month = 'month',
  Quarter = 'quarter',
  Year = 'year',
}

export enum ClaimscoreResults {
  Pass = 'pass',
  Inspect = 'inspect',
  Verify = 'verify',
  Fail = 'fail',
  Cure = 'cure',
  Insufficient = 'insufficient',
  NonClaim = 'non_claim',
  Unsupported = 'unsupported',
}

export enum AccessType {
  CredentialedAccess = 'credentialed_access',
  PublicAccess = 'public_access',
}

export enum EntityType {
  Individual = 'individual',
  Organization = 'organization',
}

export enum SubmissionType {
  Claim = 'claim',
  Other = 'other',
}

export interface DashboardFilters {
  dateRange: {
    startDate: string;
    endDate: string;
  };
  scoreRange?: Range;
  deductionCodes?: string[];
  useRealTimeClaims?: boolean;
  fileIDs?: string[];
  claimscoreResult?: ClaimscoreResults[];
  submissionType?: SubmissionType[];
  accessType?: AccessType[];
  claimEvidenceProvided?: boolean;
  claimantEntityType?: EntityType[];
}

export enum UserRole {
  Owner = 'owner',
  Admin = 'admin',
  Reviewer = 'reviewer',
  Viewer = 'viewer',
  Developer = 'developer',
}

export enum ApprovalStatus {
  Approved = 'approved',
  Pending = 'pending',
  Denied = 'denied',
}

export enum TimeRange {
  Today = 'today',
  LastWeek = 'last_7_days',
  LastMonth = 'last_30_days',
}

export interface ValidateTokenResponse {
  isTokenValid: boolean;
  isEmailVerified: boolean;
  email: string;
}

export interface UserCaseRole {
  id: string;
  role: UserRole;
}
